import { render, staticRenderFns } from "./quickBasics.vue?vue&type=template&id=0aaf8130&scoped=true&"
import script from "./quickBasics.vue?vue&type=script&lang=js&"
export * from "./quickBasics.vue?vue&type=script&lang=js&"
import style0 from "./quickBasics.vue?vue&type=style&index=0&id=0aaf8130&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf8130",
  null
  
)

export default component.exports